import { useTypedDispatch } from "@/redux/helpers/hooks";
import { getCart } from "@/redux/slices/user/thunks/getCart";
import { updateCartItem } from "@/redux/slices/user/thunks/updateCartItem";
import { Select } from "@/template/components";
import { ICartItemProps } from "../../cartInterface";

const DomainTerm = ({ item, reviewOrder }: Partial<ICartItemProps>) => {
  const dispatch = useTypedDispatch();

  const selectedTerm = item.period;

  return (
    <div
      style={{
        gridColumn: "1 / span 2",
      }}
    >
      <Select
        label="Term"
        selected={selectedTerm}
        loading={item.loading}
        disabled={item.loading || reviewOrder}
        onChange={(val) =>
          dispatch(
            updateCartItem({
              id: item.id,
              slug: `/svc/cart/item/${item.id}`,
              data: {
                action: "change_period",
                period: val,
              },
            })
          ).then(() => dispatch(getCart()))
        }
        fullWidth
        options={Array.from({ length: 10 }).map((_, i) => ({
          label: `${i + 1} Year`,
          key: i + 1,
        }))}
        popupProps={{
          width: 200,
          placement: "bottom-end",
        }}
      />
    </div>
  );
};

export default DomainTerm;
